module.exports = {
      id: "edit-usage",
      viewBox: "0 0 21.6 21.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#edit-usage",
      toString: function () {
        return this.url;
      }
    }